function employeeTraits(employee, attention) {
    const reserve = Boolean(employee && employee.lifecycle_status === 'reserve');
    const date = value => /^\d{4}-\d{2}-\d{2}$/.test(value || '') ? value : null;
    const stage = attention && attention.stage_month;
    return {
        reserve,
        terminationDate: reserve ? date(employee.termination_date) : null,
        scheduledTerminationDate: date(employee && employee.scheduled_termination_date),
        firstPayroll: Boolean(attention && attention.is_first_payroll),
        stage: Number.isInteger(stage) && stage >= 1 && stage <= 5 ? stage : null
    };
}

module.exports = {employeeTraits};
